<template>
  <div>
    <el-row :gutter="20">
      <el-col class="integration-settings" :span="20">
        <div>
          <div v-if="integrationWizardIndex >= 0">
            <div class='center-text parent'>
              <h4 class="center-text child inline-block-child">Trend Micro Configuration Setup</h4>
              <el-link class='child inline-block-child' @click="loadDocumentation('page-partner-signals-trend-micro')" :underline="false">
                <i class="material-icons">help_outline</i>
              </el-link>
            </div>
            <el-steps :active="integrationWizardIndex+1" :finish-status="apiCall.error? 'error': 'success'">
              <el-step></el-step>
              <el-step></el-step>
            </el-steps>
          </div>
          <el-carousel
            ref="wizard"
            :autoplay="false"
            :loop="false"
            indicator-position="none"
            arrow="never"
            height="400"
          >
            <el-carousel-item :key="1">
              <div class="box flex">
                <el-form :v-model="integrationWizardForm" label-width="240px" label-position="left" class="full-width">
                  <el-form-item label="Nickname">
                    <el-input
                      v-model="integrationWizardData.nickName"
                      placeholder="Enter a nickname for your connection"
                      @keydown.native.space.prevent
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="IP">
                    <el-input
                      v-model="integrationWizardData.ip"
                      placeholder="Enter an IP Address for your connection"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="Port">
                    <el-select v-model="integrationWizardData.port" placeholder="Select an Port for your connection">
                      <el-option v-for="item in logstashPorts" :key="item" :label="item" :value="item"> </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="SSL">
                    <el-switch v-model="integrationWizardData.ssl"></el-switch>
                  </el-form-item>
                  <el-form-item label="CA Certificate">
                    <el-input
                      type="textarea"
                      :rows="2"
                      :disabled="!integrationWizardData.ssl"
                      placeholder="Paste the CA Certificate"
                      v-model="integrationWizardData.caCert"
                    >
                    </el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="2" class="initiated mt-20">
              <h4 class="center-text">Initiated!</h4>
              <div class="box flex" v-loading="apiCall.outbound" element-loading-spinner="el-icon-loading"></div>
              <div class="box flex mt-20 mb-20">
                <p>
                  Please wait as we are attempting to connect to your Trend Micro account.
                </p>
              </div>
              <div class="box flex mt-20">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">View Configured Account</el-button>
              </div>
            </el-carousel-item>
            <el-carousel-item :key="3" class="initiated error mt-20">
              <h4 class="center-text">Error!</h4>
              <div class="box flex">
                <span class="center-text error-icon">
                  <i class="fas fa-exclamation-triangle"></i>
                </span>
              </div>
              <div class="box mt-20 mb-20 error-message">
                <p>
                  We could not connect to your Trend Micro account.
                </p>
                <p>
                  Troubleshoot to fix your configuration.
                </p>
                <div v-if="apiCall.error" class="box mt-20">
                  <p>
                    {{ apiCall.errorMsg.code }}:
                    {{ apiCall.errorMsg.message }}
                  </p>
                </div>
              </div>
              <div class="box flex mt-40">
                <el-button size="medium" round @click="gotoAlertIntegrationWorkflow">Troubleshoot / FAQs</el-button>
              </div>
            </el-carousel-item>
          </el-carousel>
          <div class="flex float-right">
            <span
              v-if="integrationWizardIndex >= 1"
              class="text-underline cursor-pointer back-button"
              @click="backIntegrationStep"
            >
              Go Back
            </span>
            <el-button v-if="integrationWizardIndex == 0" size="medium" round @click="updateIntegrationSettings">
              Submit
            </el-button>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import { TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST } from '@/store/modules/integrations/trendmicro-integration.type'
import integrationFormMixin from '@/components/form/integrations/integrationFormMixin'
import loadDocumentationMixin from '@/mixins/loadDocumentationMixin'

export default {
  name: 'TrendMircoIntegrationWorkflow',
  mixins: [integrationFormMixin, loadDocumentationMixin],
  data () {
    return {
      integrationLastStep: 3,
      apiDispatchState: TRENDMICRO_INTEGRATION_CONFIG_CREATE_REQUEST
    }
  },
  methods: {},
  created () {
    this.getLogstashPorts()
  },
  computed: {
    ...mapGetters(['logstashPorts'])
  },
  watch: {},
  components: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import 'assets/styles/_variables.css';
@import 'assets/styles/integration_workflow.css';

.verify-details-box {
  border: 2px solid black;
  border-radius: 10px;
  margin-top: 4%;
  padding: 32px;
  height: 80%;
  overflow: auto;
}

.inline-block-child {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/form/integrations/TrendMicroIntegrationWorkflow.vue